import React, { useEffect, useState } from 'react';
import { find } from 'lodash';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import MessageCard from '../../components/Card/MessageCard';
import Spinner from '../../components/Spinner';

import * as MessageService from '../../api/messageService';
import useMsgContext from '../../hooks/useMsgContext';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  grow: {
    flexGrow: 1,
  },
  rewardTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  subText: {
    color: '#989AA2',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stampContainer: {
    marginTop: 8,
  },
  boxContainer: {
    flex: 1,
    marginTop: 350,
  },
  refreshContainer: {
    flex: 1,
    width: 450,
    height: 600,
    marginTop: 120,
  },
  showHistoryBox: {
    marginTop: -55,
    position: 'relative',
    right: -140,
  },
  showDetailButton: {
    color: theme.palette.text.secondary,
    padding: 5,
  },
  activeCardContainer: {
    marginTop: theme.spacing(9),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '100%',
  },
  otherCard: {
    color: theme.palette.common.black,
  },
  singleStampContainer: {
    marginTop: theme.spacing(9),
  },
  indicatorContainer: {
    marginTop: theme.spacing(),
  },
  cardContainer: {
    marginTop: theme.spacing(10),
  },
  noMsgContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 200,
  },
  noMsgText: {
    color: theme.palette.action.disabled,
  },
}));

/**
 * Merchant
 */
export default function MessageScreen() {
  const classes = useStyles();
  const [messageList, setMessageList] = useState<MessageService.Message[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const msg = useMsgContext();

  useEffect(() => {
    const fetchMessageList = async () => {
      const resMessageList = await MessageService.list();
      if (resMessageList && msg) {
        const msgUnread = find(resMessageList, function (o) {
          return o.status === 'unread';
        });

        if (msgUnread) {
          msg.setMsg({
            isMessagesUnread: true,
          });
        } else {
          msg.setMsg({
            isMessagesUnread: false,
          });
        }
      }
      setMessageList(resMessageList);
      setIsLoading(false);
    };
    if (isLoading && msg) {
      fetchMessageList();
    }
  }, [isLoading, msg]);

  const handleReadPress = async (msgId: string) => {
    await MessageService.read(msgId);
    setIsLoading(true);
  };

  const handleDeletePress = async (msgId: string) => {
    await MessageService.archive(msgId);
    setIsLoading(true);
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 200,
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (messageList.length === 0) {
    return (
      <div className={classes.stampContainer}>
        <div className={classes.noMsgContainer}>
          <Typography variant="h6" className={classes.noMsgText}>
            No messages
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={classes.container}>
        <div className={classes.cardContainer}>
          {messageList.map((msg, idx) => {
            return (
              <div className={classes.stampContainer} key={idx}>
                <MessageCard
                  key={idx}
                  messageId={msg.id}
                  merchantId={msg.company.id}
                  onReadPress={() => handleReadPress(msg.id)}
                  onDeletePress={() => handleDeletePress(msg.id)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
